/** True once the user has typed anything into the certificate details form. */
export function hasMetadataInput(metadata = {}) {
  return Object.values(metadata).some(
    (value) => typeof value === "string" && value.trim() !== "",
  );
}
